export default __webpack_public_path__ + "static/media/avatar_alison2.159f44d6.mp3";